import request from '@/utils/request'

// 修改密码
export function setPsw(data) {
  return request({
    url: '/agent_admin/pwd/modify',
    method: 'post',
    data
  })
}
